/**
 * RTK VOID palette (Plan → Creative direction). Hex values only here;
 * TSL code wraps them with color(). Signage teal is a placeholder until
 * the G2 styleframes fix it.
 */
export const palette = {
  void: '#000000',
  crimson: '#E10600',
  blue: '#0040FF',
  teal: '#18E0D0',
  stone: '#0B0C0E',
  bone: '#D8D2C4',
} as const
